const ACTIVITYADD = "ACTIVITYADD";
const ACTIVITYUPDATE = "ACTIVITYUPDATE";
const ACTIVITYDELETE = "ACTIVITYDELETE";
export { ACTIVITYADD, ACTIVITYUPDATE, ACTIVITYDELETE };